import { Dialog } from "@mui/material";

export interface DialogBoxProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const DialogBox = ({ open, onClose, children }: DialogBoxProps) => {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(0,0,30,0.4)",
          },
        },
      }}
      PaperProps={{
        sx: {
          minWidth: "80%",
          height: "100%",
          overflow: "auto",
          backgroundColor: "white",
          margin: "0",
          borderRadius: "10px",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "&-ms-overflow-style:": {
            display: "none",
          },
        },
      }}
    >
      {children}
    </Dialog>
  );
};

export default DialogBox;
